// import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_BUDGET_CATEGORIES } from 'gql/budgetCategories';

const useBudgetCategoriesFilters = () => {
  const { data, loading } = useQuery(GET_BUDGET_CATEGORIES, {
    variables: { state: 'ACTIVE' },
  });
  const filters = loading
    ? []
    : data?.budgetCategories.map(({ name }) => ({
        text: name,
        value: name,
      }));

  return filters;
};

export default useBudgetCategoriesFilters;
